import ProductsModal from './ProductsModal';

export default ProductsModal;
export { default as useProductsModal, useProductsModalCleanup } from './useProductsModal';
